<template>
  <b-card>
    <b-row class="mb-3">
      <b-col sm="3">
        <b-form-group label="Nombre">
          <b-form-input
              type="text"
              placeholder="Buscar"
              class="form-control"
              v-model="dataPaginate.name"
          />
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group label="Secciones">
          <b-form-select class="form-control"
                         text-field="name"
                         value-field="id"
                         v-model="dataPaginate.slq_inventory_column_id"
                         :options="sections"
          />
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group label="Acciones">
          <b-input-group-append>
            <b-button
                variant="primary"
                @click="searching()">
              <i class="fa fa-search"/>
              <span class="d-none d-md-inline-block ml-1" v-text="'Buscar'"/>
            </b-button>
            <b-button
                @click="clearFilter()">
              <i class="fa fa-eraser"/>
              <span class="d-none d-md-inline-block ml-1" v-text="' Limpiar'"/>
            </b-button>
          </b-input-group-append>
        </b-form-group>
      </b-col>

      <!-- Boton de crear -->
      <b-col sm="3">
        <b-button variant="info" class="float-right mt-4" to="/inventories/create-column">
          <i class="fa fa-plus" />
          <span class="d-none d-md-inline-block ml-1" v-text="' Nueva columna'" />
        </b-button>
      </b-col>

    </b-row>

    <b-row>
      <b-col>
        <b-table
            responsive
            :items="dataColums.data"
            :fields="columns"
            thead-tr-class="table-active"
            class="mb-2"
        >

          <!-- Columna color -->
          <template class="text-center" v-slot:cell(color)="data">
            <div class="data-color"
                 :style="[{ 'background-color': data.item.color }]">
            </div>
          </template>

          <!-- Columna nombre -->
          <template v-slot:cell(name)="data">
            <GuardIsProtected :isProtected="data.item.inventory_section.is_protected" :name="data.item.name" infoHelper="Columna protegida, no puedes realizar acciones sobre ella" />
          </template>

          <!-- Columna seccion -->
          <template v-slot:cell(inventory_section.name)="data">
            <GuardIsProtected :isProtected="data.item.inventory_section.is_protected" :name="data.item.inventory_section.name" />
          </template>

          <!-- Columna orden -->
          <template class="text-center clickeable" v-slot:cell(order_column)="data">
            <div v-if="!data.item.inventory_section.is_protected">
              <span v-if="data.item.edit"
                  style="cursor: pointer">
                        <b-form-select class="form-control"
                                       v-model="slqInventoryColumn.order_column"
                                       :options="data.item.order_available">
                        </b-form-select>
              </span>
              <b-button  v-else-if="data.item.name === 'Contador'"
                        variant="link">1
              </b-button>
              <b-button variant="link" v-else
                        @click="editOrder(data.item)">
                {{ data.item.order_column ? data.item.order_column : '--' }}
              </b-button>
            </div>
            <div v-else class="ml-3">
              {{ data.item.order_column ? data.item.order_column : '--' }}
            </div>
          </template>


          <template v-slot:cell(actions)="data">

            <el-tooltip
                v-if="data.item.edit"
                effect="dark"
                placement="top-start"
                content="Guardar">

              <b-btn variant="dark"
                     class="mr-2 mt-1"
                     size="sm"
                     @click="editOrder(data.item)">
                <i class="fa fa-save"/>
              </b-btn>
            </el-tooltip>


            <el-tooltip
                v-else
                effect="dark"
                placement="top-start"
                content="Editar">

              <b-btn variant="info"
                     class="mr-2 mt-2"
                     size="sm"
                     @click="edit(data.item.id)">
                <i class="fa fa-edit"/>
              </b-btn>
            </el-tooltip>
          </template>
        </b-table>

        <el-pagination
            v-if="dataColums.data && !!dataColums.data.length"
            v-model="dataPaginate.page"
            @size-change="getColum"
            @current-change="getColum"
            :current-page.sync="dataPaginate.page"
            class="float-right"
            :page-size.sync="dataPaginate.perPage"
            :page-sizes="[10, 30, 50, 100]"
            layout="total, sizes, prev, pager, next"
            :total="dataColums.total"
        />
      </b-col>
    </b-row>
  </b-card>
</template>
<script>

// Generales
import { mapState, mapMutations, mapActions } from "vuex";

// Componentes
import GuardIsProtected from '../components/sections/GuardIsProtected.vue'

export default {

  name: 'InventoryColumsIndex',

  components: {
    GuardIsProtected
  },

  data() {
    return {
      columns: [
        {
          key: "name",
          label: "Nombre",
          sortable: true,
          tdClass: "text-left",
          thClass: "text-left",
          thStyle: "width: 80px; max-width:80px",
        },
        {
          key: "color",
          label: "Color",
          sortable: false,
          tdClass: "text-left",
          thClass: "text-left",
          thStyle: "width: 80px; max-width:80px",
        },
        {
          key: "inventory_section.name",
          label: "Sección",
          sortable: true,
          tdClass: "text-left",
          thClass: "text-left",
          thStyle: "width: 80px; max-width:80px",
        },
        {
          key: "order_column",
          label: "Orden",
          sortable: true,
          tdClass: "text-left",
          thClass: "text-left",
          thStyle: "width: 80px; max-width:80px",
        },
        {
          key: "actions",
          label: "Operaciones",
          tdClass: "text-left",
          thClass: "text-left",
          thStyle: "width: 80px; max-width:80px",
        },
      ],
      dataColums: [],
      sections: [],
      slqInventoryColumn: null,
      isEditing: false,
      currentId: null
    };
  },
  computed: {
    ...mapState("colums", ["dataPaginate"]),
  },
  async mounted() {
    this.load(false);
    await this.getColum();
    await this.getSections()
  },
  methods: {
    ...mapActions("sections", ["listAllSections"]),
    ...mapActions("colums", ["updateColumn"]),
    async getColum() {
      const res = await this.getColums(this.dataPaginate);
      this.dataColums = res;
      this.dataColums.data = res.data.map(obj => ({ ...obj, edit: false }))
    },
    async getSections() {
      const res = await this.listAllSections();
      this.sections = res;
    },
    async searching() {
      this.dataPaginate.page = 1;
      const res = await this.getColums(this.dataPaginate);
      this.dataColums = res;
      this.dataColums.data = res.data.map(obj => ({...obj, edit: false}))
    },

    edit(id) {
      this.$router.push({
        path: "/inventories/update-column/" + id,
      });
    },
    async editOrder(item) {
      if (this.isEditing && this.currentId !== item.id) return;
      item.edit = !item.edit;
      this.currentId = item.id;
      this.isEditing = item.edit ? true : false;
      this.slqInventoryColumn = item;
      if (!item.edit) {
        await this.updateColumn({
          payload: {
            id: this.slqInventoryColumn.id,
            order_column: this.slqInventoryColumn.order_column,
          },
          callback: async (success) => {
            if (!success) return;
            await this.getColum();
          }
        });
      }
    },
    clearFilter() {
      this.resetDataPagination()
      this.getColum();
    },

    ...mapMutations("dashboard", ["load"]),
    ...mapMutations("colums", ["resetDataPagination"]),
    _validarPermiso(permiso) {
      return true;
    },
    ...mapActions("colums", ["getColums"]),
  },
};
</script>
<style>
.data-color {
  border-radius: 1px;
  width: 50px;
  height: 25px;
}
</style>
